// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ab-tests-cards-container{padding-top:10rem}`, "",{"version":3,"sources":["webpack://./src/views/Strategy/AbTests/AbTests.scss"],"names":[],"mappings":"AAEA,0BACE,iBAAA","sourcesContent":["@import '_variables';\n\n.ab-tests-cards-container {\n  padding-top: 10rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
